import Config from 'services/config/local';

const CUSTIFY_SCRIPT_URL = 'https://assets.custify.com/assets/track.min.js';
const CUSTIFY_METHODS = [
    'identify', 'track', 'setInstance', 'setAccount', 'trackTime',
    'stopTrackTime', 'debug', 'setOptions', 'triggerPendingAction', 'closePendingAction'
];

/* @ngInject */
export default class CustifyTrackingService {
    constructor(AuthService, ProjectManager) {
        this.AuthService = AuthService;
        this.ProjectManager = ProjectManager;
        this.ready = false;
        this.identifiedCompanyId = null;
        this.init();
    }

    init() {
        // Docs: https://docs.custify.com/#section/JAVASCRIPT/Send-data-using-the-JavaScript-snippet
        const accountId = Config.custify && Config.custify.accountId;
        if (!accountId) {
            return;
        }
        // Set up the async stub queue — same pattern as the standard Custify snippet.
        // Calls made before the script finishes loading are queued and replayed on load.
        // eslint
        window._ctrack = window._ctrack || []; // eslint-disable-line no-underscore-dangle
        CUSTIFY_METHODS.forEach(method => {
            window._ctrack[method] = function(...args) { // eslint-disable-line no-underscore-dangle
                window._ctrack.push([method].concat(args)); // eslint-disable-line no-underscore-dangle
            };
        });

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = CUSTIFY_SCRIPT_URL;
        document.head.appendChild(script);

        window._ctrack.setAccount(accountId); // eslint-disable-line no-underscore-dangle
        window._ctrack.setOptions({ createOrUpdateEntities: true }); // eslint-disable-line no-underscore-dangle

        this.ready = true;
    }

    trackEvent(eventName, metadata = {}) {
        if (!this.ready) return;
        const companyId = this.getCompanyId();
        const organizationDisplayName = this.ProjectManager.currentProject?.organizationDisplayName;

        if (!companyId) {
            return;
        }

        // Automatically identify the company if it has changed or not yet identified
        if (this.identifiedCompanyId !== companyId) {
            this.identify({ company_id: companyId }, null, { name: organizationDisplayName });
            this.identifiedCompanyId = companyId;
        }

        const userId = this.AuthService.getUserId();
        const email = this.AuthService.getAuthData()?.profile?.email;
        const isDTEmployee = typeof email === 'string' && email.includes('@disruptive-technologies.com');
        const payload = Object.assign({
            companyId,
            userId,
            isDTEmployee,
        }, metadata);

        this.track(eventName, payload);
    }

    getCompanyId() {
        return this.ProjectManager.currentProject?.organizationId ||
               this.ProjectManager.currentProject?.organization?.split("/")[1];
    }

    track(eventName, payload) {
        if (!this.ready) {
            return;
        }
        try {
            window._ctrack.track(eventName, payload); // eslint-disable-line no-underscore-dangle
        } catch (e) {
            // Silently fail if Custify is blocked by an ad blocker or failed to load
        }
    }

    identify(identifiers, peopleTraits, companyTraits) {
        if (!this.ready) {
            return;
        }
        try {
            window._ctrack.identify(identifiers, peopleTraits, companyTraits); // eslint-disable-line no-underscore-dangle
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`CustifyTrackingService: Error identifying: ${e}`);
        }
    }
}
